import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  modals: {
    delete: {
      open: false,
      id: null,
    },
  },
};

const lawControlSlice = createSlice({
  name: "lawControl",
  initialState: initialState,
  reducers: {
    openModal: (state, action) => {
      const { id, modalType } = action.payload;
      state.modals[modalType] = { open: true, id };
    },
    closeModal: (state, action) => {
      const { modalType } = action.payload;
      state.modals[modalType] = { open: false, id: null };
    },
  },
});

export const { openModal, closeModal } = lawControlSlice.actions;
export default lawControlSlice.reducer;
